<div class="core-popup-list-selector-wrapper px-1 d-flex justify-content-between align-items-center">
  <div *ngIf="value.length == 0">
    <label>No selection</label>
  </div>
  <div *ngIf="value.length > 0 && (!config.showMoreLabelAfterTotItems || value.length <= config.showMoreLabelAfterTotItems)">
    <span class="m-1 px-1 core-popup-list-selector-item" *ngFor="let item of value; let index = index">
      <label>{{ getLabelOfItem(item) }}</label>
      <i class="fa fa-close mx-1" style="cursor: pointer;"
       *ngIf="!config.internalDisabled" (click)="removeItem(index); applyValueChange();"></i>
    </span>
  </div>
  <div *ngIf="value.length > 0 && !!config.showMoreLabelAfterTotItems && value.length > config.showMoreLabelAfterTotItems">
    <span class="m-1 px-1 core-popup-list-selector-item">
      <label>{{ getLabelOfItem(value[0]) }} and {{value.length - 1 }} more</label>
    </span>
  </div>
  <dx-button
    stylingMode="contained" type="normal"
    text="..." (onClick)="openPopupSelector()">
  </dx-button>
</div>
